<template>
    <v-autocomplete
        v-model="usuario"
        variant="solo"
        :items="usuarios"
        item-title="username"
        item-value="id"
        label="Seleccionar Usuario"
        :rules="obligatorio"
        class="asterisco"
        :loading="cargandoUsuarios"
        @update:model-value="usuarioSeleccionado"
    ></v-autocomplete>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert = false"
    ></AlertComponent>
</template>

<script>
    import { obligatorio } from '@/_helpers/rules';
    import AuthService from '@/api/AuthService';
    import AlertComponent from './AlertComponent.vue';

    const authService = new AuthService();

    export default {
        name: 'UsuarioSelect',
        components: {
            AlertComponent
        },
        props: {
            rolesUsuarios: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                usuario: null,
                usuarios: [],
                cargandoUsuarios: false,
                obligatorio: obligatorio,
                //datos para alert
                alertTitle: '',
                alertText: '',
                alertType: '',
                showAlert: false
            }
        },
        async mounted() {
            await this.cargarUsuarios();
        },
        methods: {
            async cargarUsuarios() {
                this.cargandoUsuarios = true;
                const response = await authService.getUsuariosPorRoles(this.rolesUsuarios);
                if(response && response.status === 200){
                    this.usuarios = response.data;
                }
                else {
                    this.alertTitle = 'Error';
                    this.alertText = response && response.data? response.data : 'No se pudieron cargar los usuarios';
                    this.alertType = 'error';
                    this.showAlert = true;
                }
                this.cargandoUsuarios = false;
            },
            usuarioSeleccionado(usuario) {
                this.$emit('usuario-seleccionado', usuario);
            }
        }
    }
</script>
